{
  "collapse": "Recolher",
  "expand": "Expandir"
}
